import React from "react";
import ReactQuill from "react-quill";
import ImageFormat from "./imageFormat";
import Block from "./block";
import { translate } from "react-i18next";
const { Quill } = ReactQuill;
import "../../css/react-quill.css";
import ImageResize from "quill-image-resize-module-react";
const Font = Quill.import("formats/font");
const FONT_ARRAY = [
  "arial",
  "calibri",
  "courier",
  "georgia",
  "lucida",
  "open",
  "roboto",
  "tahoma",
  "times",
  "trebuchet",
  "verdana",
];

Font.whitelist = FONT_ARRAY;

Quill.register(Font, true);
const DirectionAttribute = Quill.import("attributors/attribute/direction");
Quill.register(DirectionAttribute, true);

const AlignClass = Quill.import("attributors/class/align");
Quill.register(AlignClass, true);

const BackgroundClass = Quill.import("attributors/class/background");
Quill.register(BackgroundClass, true);

const ColorClass = Quill.import("attributors/class/color");
Quill.register(ColorClass, true);

const DirectionClass = Quill.import("attributors/class/direction");
Quill.register(DirectionClass, true);

const FontClass = Quill.import("attributors/class/font");
Quill.register(FontClass, true);

const SizeClass = Quill.import("attributors/class/size");
Quill.register(SizeClass, true);

const AlignStyle = Quill.import("attributors/style/align");
Quill.register(AlignStyle, true);

const BackgroundStyle = Quill.import("attributors/style/background");
Quill.register(BackgroundStyle, true);

const ColorStyle = Quill.import("attributors/style/color");
Quill.register(ColorStyle, true);

const DirectionStyle = Quill.import("attributors/style/direction");
Quill.register(DirectionStyle, true);

const FontStyle = Quill.import("attributors/style/font");
Quill.register(FontStyle, true);

const SizeStyle = Quill.import("attributors/style/size");
Quill.register(SizeStyle, true);
Quill.register("modules/imageResize", ImageResize);
Quill.register(ImageFormat, true);
Quill.register(Block, true);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike", "image"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],

  ["clean"], // remove formatting button
];
class TextEditor extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { name, onChange, value } = this.props;

    return (
      <div className="text-editor">
        {/* <Toolbar fonts={FONT_ARRAY} /> */}
        <ReactQuill
          modules={{
            toolbar: toolbarOptions,
            imageResize: {
              modules: ["Resize"],
            },
            clipboard: {
              matchVisual: false,
            },
          }}
          onChange={(value) => {
            onChange({
              target: {
                name: name,
                value: value,
              },
            });
          }}
          value={value}
        />
      </div>
    );
  }
}
export default translate("translations")(TextEditor);
